import DepositoService from '@/services/deposito_service.js';
import ConceptoService from '@/services/concepto_service.js';
import EntidadesService from '@/services/entidades_service.js';
import TalonarioService from '@/services/talonario_service.js';
import MaterialTipoService from '@/services/material_tipo_service.js';
import { UbicacionService } from '@/services/ubicacion_service.js';
import {
  tipoComprobantes,
  tipoMovimientos,
} from '@/views/inventory_movement/inventory_data.js';

export const reportsFiltersConfig = {
  comprobante: [
    {
      key: 'FechaDesde',
      label: 'Fecha desde',
      type: 'date',
      span: 6,
      operator: 'gte',
      order: 3,
    },
    {
      key: 'FechaHasta',
      label: 'Fecha hasta',
      type: 'date',
      span: 6,
      operator: 'lte',
      order: 4,
    },
    {
      key: 'PrefijoInterno',
      label: 'Prefijo interno',
      type: 'input',
      fixed: true,
      span: 6,
      operator: 'eq',
      order: 1,
    },
    {
      key: 'NumeroInterno',
      label: 'Número',
      type: 'input',
      placeholder: 'Ingresar número',
      fixed: true,
      span: 6,
      operator: 'eq',
      order: 2,
    },
    {
      key: 'OT',
      label: 'OT',
      type: 'input',
      placeholder: 'Orden de trabajo',
      span: 3,
      operator: 'contains',
    },
    {
      key: 'OC',
      label: 'OC',
      type: 'input',
      placeholder: 'Orden de compra',
      span: 3,
      operator: 'contains',
    },
    {
      key: 'Lote',
      label: 'Lote',
      type: 'input',
      placeholder: 'Lote',
      span: 3,
      operator: 'contains',
    },
    {
      key: 'Ubicacion',
      keyTarget: 'CodigoUbicaciones',
      label: 'Ubicacion',
      type: 'select',
      placeholder: 'Seleccionar ubicaciones',
      fetchOptions: async () => {
        const res = await UbicacionService.findAll({ page: 0, Activo: true });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      multiple: true,
      operator: 'eq',
    },
  ],
  listado_de_comprobantes: [
    {
      key: 'FechaInterna',
      label: 'Fecha Interna',
      type: 'date_range',
      keyDesde: 'FechaInternaDesde',
      keyHasta: 'FechaInternaHasta',
      fixed: true,
      span: 7,
      operator: 'gte|lte',
    },
    {
      key: 'FechaExterna',
      label: 'Fecha Externa',
      type: 'date_range',
      keyDesde: 'FechaExternaDesde',
      keyHasta: 'FechaExternaHasta',
      span: 7,
      operator: 'gte|lte',
    },
    {
      key: 'TalonarioInterno',
      label: 'Talonario Interno',
      type: 'select_input',
      keySelect: 'TalonarioInterno',
      keyInput: 'TalonarioInternoNumero',
      placeholderSelect: 'Talonario...',
      placeholderInput: 'Número...',
      fetchOptions: async () => {
        const res = await TalonarioService.findAll({ page: 0, Activo: true });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Prefijo',
      span: 5,
      operator: 'eq',
    },
    {
      key: 'TalonarioExterno',
      label: 'Talonario Externo',
      type: 'select_input',
      keySelect: 'TalonarioExterno',
      keyInput: 'TalonarioExternoNumero',
      placeholderSelect: 'Talonario...',
      placeholderInput: 'Número...',
      fetchOptions: async () => {
        const res = await TalonarioService.findAll({ page: 0, Activo: true });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Prefijo',
      span: 5,
      operator: 'eq',
    },
    {
      key: 'TipoComprobante',
      label: 'Tipo Comprobante',
      type: 'select',
      placeholder: 'Seleccionar tipo',
      options: tipoComprobantes,
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      span: 3,
      operator: 'eq',
    },
    {
      key: 'Movimiento',
      label: 'Movimiento',
      type: 'select',
      placeholder: 'Seleccionar movimiento',
      options: tipoMovimientos,
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      span: 3,
      operator: 'eq',
    },
    {
      key: 'Entidad',
      label: 'Entidad',
      type: 'select',
      placeholder: 'Buscar cliente / proveedor...',
      searchFn: async (query) => {
        const res = await EntidadesService.findAll({ Descripcion: query, page: 0, Activo: true });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      minChars: 3,
      operator: 'eq',
    },
    {
      key: 'Conceptos',
      keyTarget: 'CodigoConceptos',
      label: 'Concepto',
      type: 'select',
      placeholder: 'Seleccionar conceptos',
      fetchOptions: async () => {
        const res = await ConceptoService.findAll({ page: 0, Activo: true });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      multiple: true,
      operator: 'eq',
    },
    {
      key: 'Depositos',
      keyTarget: 'CodigoDepositos',
      label: 'Depósito',
      type: 'select',
      placeholder: 'Seleccionar depósitos',
      span: 3,
      fetchOptions: async () => {
        const res = await DepositoService.findAll({ page: 0, Activo: true });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      multiple: true,
      operator: 'eq',
    },
    {
      key: 'DepositosDestino',
      keyTarget: 'CodigoDepositosDestino',
      label: 'Depósito Destino',
      type: 'select',
      placeholder: 'Seleccionar depósitos destino',
      span: 3,
      fetchOptions: async () => {
        const res = await DepositoService.findAll({ page: 0, Activo: true });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      multiple: true,
      operator: 'eq',
    },
    {
      key: 'DescripcionItem',
      label: 'Descripción Item',
      type: 'input',
      placeholder: 'Descripción del material',
      operator: 'contains',
    },
    {
      key: 'CodigoItem',
      label: 'Código Item',
      type: 'input',
      placeholder: 'Código',
      span: 3,
      operator: 'contains',
    },
    {
      key: 'Serie',
      label: 'Serie',
      type: 'input',
      placeholder: 'Número de serie',
      span: 3,
      operator: 'contains',
    },
    {
      key: 'OT',
      label: 'OT',
      type: 'input',
      placeholder: 'Orden de trabajo',
      span: 3,
      operator: 'contains',
    },
    {
      key: 'Lote',
      label: 'Lote',
      type: 'input',
      placeholder: 'Lote',
      span: 3,
      operator: 'contains',
    },
  ],
  listado_de_existencias: [
    {
      key: 'Puntos',
      label: 'Puntos',
      type: 'select',
      placeholder: 'Seleccionar punto',
      options: [
        { Codigo: 'todos', Descripcion: 'Todos' },
        { Codigo: 'debajo_minimo', Descripcion: 'Cant debajo del mínimo' },
        { Codigo: 'encima_maximo', Descripcion: 'Cant encima del máximo' },
        { Codigo: 'debajo_reposicion', Descripcion: 'Cant debajo del punto de reposición' },
      ],
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      span: 8,
      operator: 'isFixed',
    },
    {
      key: 'Depositos',
      keyTarget: 'CodigoDepositos',
      label: 'Depósito',
      type: 'select',
      placeholder: 'Seleccionar depósitos',
      span: 6,
      fetchOptions: async () => {
        const res = await DepositoService.findAll({ page: 0, Activo: true });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      multiple: true,
      operator: 'in',
    },
    {
      key: 'DescripcionItem',
      label: 'Descripción Item',
      type: 'input',
      placeholder: 'Descripción del material',
      span: 8,
    },
    {
      key: 'CodigoItem',
      label: 'Código Item',
      type: 'input',
      placeholder: 'Código',
      span: 6,
      operator: 'contains',
    },
    {
      key: 'CodigoAdicionalItem',
      label: 'Código Adicional',
      type: 'input',
      placeholder: 'Código adicional',
      span: 6,
      operator: 'contains',
    },
    {
      key: 'MaterialTipo',
      keyTarget: 'CodigosMaterialTipo',
      label: 'Tipo Material',
      type: 'select',
      placeholder: 'Seleccionar tipo material',
      span: 6,
      fetchOptions: async () => {
        const res = await MaterialTipoService.findAll({
          page: 0,
          Activo: true,
          sortBy: 'Descripcion',
          sort: 'asc',
        });
        return res?.data || [];
      },
      fieldKey: 'Codigo',
      fieldLabel: 'Descripcion',
      multiple: true,
      operator: 'in',
    },
  ],
};

/*

por cada filtro fixed: true en reportsFiltersConfig, agregar una validación aquí
para ser usada en el evento onFilter de reports_filters.vue

*/

export const reportsFiltersValidations = {
  comprobante: [
    {
      key: 'PrefijoInterno',
      message: 'Debe ingresar prefijo interno',
    },
    {
      key: 'NumeroInterno',
      message: 'Debe ingresar número interno',
    },
  ],
  listado_de_comprobantes: [
    {
      key: 'FechaInterna',
      message: 'Debe ingresar fecha interna',
    },
  ],
};
